// 测试数据 - 从小程序版本转换而来

export const shortTestData = {
  "questions": [
    {
      "id": 1,
      "text": "我担心我的伴侣不像我爱他/她那样爱我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 2,
      "text": "我发现让伴侣完全依赖我，我并不舒服",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 3,
      "text": "我经常希望伴侣对我的感情和我对他们的感情一样强烈",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 4,
      "text": "我宁愿不依赖伴侣，也不想让伴侣依赖我",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 5,
      "text": "我担心伴侣没有我想象中那么爱我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 6,
      "text": "我发现很难向伴侣敞开心扉",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 7,
      "text": "我对伴侣的感情感到不安，害怕被拒绝",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 8,
      "text": "我不愿意和伴侣分享太多私人感受",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 9,
      "text": "我很少担心伴侣会离开我",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 10,
      "text": "我很乐意与伴侣分享我的感受和想法",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 11,
      "text": "我发现自己并不怎么担心伴侣对我的看法",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 12,
      "text": "我很享受与伴侣亲密相处",
      "dimension": "Avoidance",
      "reverse": true
    }
  ],
  "scoring": {
    "reverse_scoring": {
      "items": [9, 11, 10, 12]
    }
  }
};

export const fullTestData = {
  "questions": [
    {
      "id": 1,
      "text": "我担心伴侣不像我爱他/她那样爱我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 2,
      "text": "我发现很难依赖伴侣",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 3,
      "text": "我经常希望伴侣对我的感情，和我对他们的感情一样强烈",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 4,
      "text": "我宁愿不依赖伴侣，也不想让伴侣依赖我",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 5,
      "text": "我担心伴侣没有我想象中那么爱我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 6,
      "text": "我发现很难向伴侣敞开心扉",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 7,
      "text": "我对伴侣的感情感到不安，害怕被拒绝",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 8,
      "text": "我不愿意和伴侣分享太多私人感受",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 9,
      "text": "我很少担心伴侣会离开我",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 10,
      "text": "我很乐意与伴侣分享我的感受和想法",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 11,
      "text": "我并不怎么担心伴侣对我的看法",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 12,
      "text": "我很享受与伴侣亲密相处",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 13,
      "text": "我常常害怕伴侣会对我失去兴趣",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 14,
      "text": "我发现与伴侣过于亲密让我感到不适",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 15,
      "text": "我担心自己对伴侣来说不够好",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 16,
      "text": "我更喜欢保持独立，而不是与伴侣过于亲近",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 17,
      "text": "我害怕伴侣不重视我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 18,
      "text": "我发现自己很难接受伴侣的依赖",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 19,
      "text": "我对伴侣的感情让我感到安全",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 20,
      "text": "我很愿意与伴侣讨论我的问题和担忧",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 21,
      "text": "我很少担心伴侣会拒绝我",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 22,
      "text": "我发现与伴侣的亲密关系，让我感到放松",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 23,
      "text": "我担心伴侣会突然离开我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 24,
      "text": "我更喜欢不与伴侣分享太多私人想法",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 25,
      "text": "我常常觉得自己需要伴侣的更多关注",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 26,
      "text": "我发现自己不愿意与伴侣过于亲密",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 27,
      "text": "我担心伴侣不真正关心我",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 28,
      "text": "我发现很难完全信任伴侣",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 29,
      "text": "我对伴侣的感情，让我感到安心",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 30,
      "text": "我很愿意与伴侣分享我的内心世界",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 31,
      "text": "我很少担心伴侣对我的感情",
      "dimension": "Anxiety",
      "reverse": true
    },
    {
      "id": 32,
      "text": "我发现与伴侣的亲密关系让我感到满足",
      "dimension": "Avoidance",
      "reverse": true
    },
    {
      "id": 33,
      "text": "我担心伴侣会觉得我过于黏人",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 34,
      "text": "我很难接受伴侣的亲密需求",
      "dimension": "Avoidance",
      "reverse": false
    },
    {
      "id": 35,
      "text": "我常常觉得自己需要更多来自伴侣的肯定",
      "dimension": "Anxiety",
      "reverse": false
    },
    {
      "id": 36,
      "text": "我更喜欢与伴侣保持一定距离",
      "dimension": "Avoidance",
      "reverse": false
    }
  ],
  "scoring": {
    "reverse_scoring": {
      "items": [9, 11, 19, 21, 29, 31, 10, 12, 20, 22, 30, 32]
    }
  }
};

export const introData = {
  "general_introduction": {
    "title": "依恋型人格测试",
    "content": "依恋型人格测试帮助你了解在亲密关系中的情感模式，揭示你在恋爱或婚姻中的行为倾向。测试基于心理学依恋理论，测量'依恋焦虑'（担心被拒绝）和'依恋回避'（抗拒亲密）两个维度，得出四种依恋类型：安全型、焦虑型、回避型、恐惧型。选择快速测试（12题）或深度测试（36题），了解自己并获得关系建议。",
    "scientific_basis": "基于《亲密关系经历量表》（ECR），由Brennan等人1998年开发，信度0.90以上，中文版经李同归等2006年验证，广泛用于心理学研究。"
  },
  "versions": [
    {
      "version": "ECR-S (12-Item Version)",
      "title": "快速测试（12题）",
      "content": "12题测试，耗时2-3分钟，测量依恋焦虑和回避，适合快速了解依恋风格。结果包括依恋类型和简要建议。",
      "scientific_basis": "基于Wei等人2007年ECR短版，信度0.78-0.86，与原始ECR相关性0.90，中文题目适配中国用户。",
      "ideal_for": "时间有限或想快速了解的用户。"
    },
    {
      "version": "ECR (36-Item Version)",
      "title": "深度测试（36题）",
      "content": "36题测试，耗时5-7分钟，全面测量依恋焦虑和回避，覆盖亲密关系的多个面向。结果包括详细分析和建议。",
      "scientific_basis": "基于Brennan等人1998年ECR完整版，信度0.90-0.94，中文版经李同归等2006年验证，适合深入研究。",
      "ideal_for": "想深入了解依恋风格或改善关系的用户。"
    }
  ],
  "why_two_versions": {
    "title": "两种版本的区别",
    "content": "快速测试（12题）简洁高效，适合快速评估；深度测试（36题）更全面精准，适合深入分析。两者均科学可靠，满足不同需求。",
    "comparison": {
      "ECR-S": {
        "questions": 12,
        "time": "2-3分钟",
        "precision": "高，快速评估",
        "ideal_for": "初学者"
      },
      "ECR": {
        "questions": 36,
        "time": "5-7分钟",
        "precision": "极高，深入分析",
        "ideal_for": "深入探索"
      }
    }
  }
};
